import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* createUser() {
  yield takeEvery(actions.CREATE_USER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/user`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_USER_ENDED });
    }
  });
}

function* searchUsers() {
  yield takeEvery(actions.SEARCH_USERS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/user?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_USERS_ENDED });
    }
  });
}

function* getAccountFilterFormRoles() {
  yield takeEvery(actions.GET_ACCOUNT_FILTER_FORM_ROLES, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/user/search/filter/menu`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_ACCOUNT_FILTER_FORM_ROLES_ENDED });
    }
  });
}

function* getAccountCreationFormRoles() {
  yield takeEvery(actions.GET_ACCOUNT_CREATION_FORM_ROLES, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/user/create/field/menu`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_ACCOUNT_CREATION_FORM_ROLES_ENDED });
    }
  });
}

function* findUser() {
  yield takeEvery(actions.FIND_USER, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/user/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_USER_ENDED });
    }
  });
}

function* updateUser() {
  yield takeEvery(actions.UPDATE_USER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/user`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_USER_ENDED });
    }
  });
}

function* updateUserStatus() {
  yield takeEvery(actions.UPDATE_USER_STATUS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/user/status`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_USER_STATUS_ENDED });
    }
  });
}

function* updateUserProfile() {
  yield takeEvery(actions.UPDATE_USER_PROFILE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/user/my/data`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_USER_PROFILE_ENDED });
    }
  });
}

function* updateUserPassword() {
  yield takeEvery(actions.UPDATE_USER_PASSWORD, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/user/my/password`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_USER_PASSWORD_ENDED });
    }
  });
}

function* resetUserPassword() {
  yield takeEvery(actions.RESET_USER_PASSWORD, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/user/reset/password`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.RESET_USER_PASSWORD_ENDED });
    }
  });
}

function* createRole() {
  yield takeEvery(actions.CREATE_ROLE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/user/role`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_ROLE_ENDED });
    }
  });
}

function* searchRoles() {
  yield takeEvery(actions.SEARCH_ROLES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/user/role?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_ROLES_ENDED });
    }
  });
}

function* findRole() {
  yield takeEvery(actions.FIND_ROLE, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/user/role/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_ROLE_ENDED });
    }
  });
}

function* getUserRoles() {
  yield takeEvery(actions.GET_USER_ROLES, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/user/role/my/data`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_USER_ROLES_ENDED });
    }
  });
}

function* updateRole() {
  yield takeEvery(actions.UPDATE_ROLE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/user/role`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_ROLE_ENDED });
    }
  });
}

function* deleteRoles() {
  yield takeEvery(actions.DELETE_ROLES, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/user/role`, {
        data,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_ROLES_ENDED });
    }
  });
}

function* getPermissions() {
  yield takeEvery(actions.GET_PERMISSIONS, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/user/role/create/role/field/menu`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_PERMISSIONS_ENDED });
    }
  });
}

function* getUsersInfo() {
  yield takeEvery(actions.GET_USERS_INFO, function* (action) {
    const { userIds, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/user/getUsersInfo?user_ids=${userIds.join(',')}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_USERS_INFO_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createUser),
    fork(searchUsers),
    fork(getAccountFilterFormRoles),
    fork(getAccountCreationFormRoles),
    fork(findUser),
    fork(updateUser),
    fork(resetUserPassword),
    fork(updateUserStatus),
    fork(updateUserProfile),
    fork(updateUserPassword),
    fork(createRole),
    fork(searchRoles),
    fork(findRole),
    fork(getUserRoles),
    fork(updateRole),
    fork(deleteRoles),
    fork(getPermissions),
    fork(getUsersInfo),
  ]);
}
